import React, { Fragment, useState, useEffect, useContext } from "react";
import { Context as GamesContext } from "../context/GamesContext";
import ModalContainer from "../components/ModalContainer";
import CreateGameContext from "../components/CreateGameContent";
import { ControllerCard } from "../components/Cards";

const Games = ({ user }) => {
  const [search, setSearch] = useState("");
  const stepTitleContent = [
    {
      step: 1,
      content: "Select a Product",
    },
    {
      step: 2,
      content: "Customize Game Details",
    },
    {
      step: 3,
      content: "Invite Participants",
    },
  ];

  const {
    state,
    getGameGroupList,
    getProductLibrary,
    formNavigate,
    createGame,
    toggleGameModal,
  } = useContext(GamesContext);
  const {
    formStep,
    maxFormStep,
    gameDetailsValidated,
    createGameFormValidated,
    game_card_list,
    gameModal,
    game_group_nameValidated,
    game_group_playersValidated,
    game_group_name,
    tag_list,
    selected_product,
    world_count,
    game_group_invite_list,
  } = state;

  //TODO: When route loads, get the following:
  // - Games Created and Purchased by the user
  // - Product Library
  // - User List "Full Name, Avatar, email"

  useEffect(() => {
    const user_id = user.id;
    getGameGroupList({ user_id });
    getProductLibrary();
  }, []);

  const submitGame = () => {
    const product_id = selected_product.id;
    const user_id = user.id;
    createGame({
      game_group_name,
      tag_list,
      product_id,
      user_id,
      world_count,
      game_group_invite_list,
    });
  };
  return (
    <Fragment>
      <ModalContainer
        isOpen={gameModal}
        onClick={() => toggleGameModal(gameModal)}
        formStep={formStep}
        maxFormStep={maxFormStep}
        stepTitleContent={stepTitleContent}
      >
        <CreateGameContext />
        <div className="flex flex-col lg:flex-row lg:space-x-5 space-y-2 lg:justify-between z-0 py-10">
          <div className="flex justify-start items-center z-10">
            <svg
              fill="none"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="text-rose-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <div className="ml-1 text-coolGray-400 font-xs">
              All fields required
            </div>
          </div>
          <div className="flex lg:justify-end space-x-5">
            {formStep > 1 ? (
              <button
                className="py-2 px-5 text-coolGray-600 bg-emerald-400 text-lg hover:text-coolGray-100 hover:bg-emerald-500 font-medium cursor-pointer transition duration-100 rounded"
                onClick={() => formNavigate({ diff: -1 })}
              >
                previous
              </button>
            ) : null}
            {formStep === 2 ? (
              <button
                className={`py-2 px-5 text-coolGray-600 bg-emerald-400 text-lg font-medium cursor-pointer transition duration-100 rounded z-10${
                  !game_group_nameValidated || !game_group_playersValidated
                    ? " opacity-50 cursor-not-allowed hover:"
                    : "hover:text-coolGray-100 hover:bg-emerald-500"
                }`}
                onClick={() => formNavigate({ diff: 1 })}
                disabled={
                  !game_group_nameValidated && !game_group_playersValidated
                    ? true
                    : false
                }
              >
                Next
              </button>
            ) : null}
            {formStep === maxFormStep ? (
              <button
                className={`py-2 px-5 text-coolGray-600 bg-emerald-400 text-lg font-medium uppercase cursor-pointer transition duration-100 rounded z-10 ${
                  !game_group_nameValidated || !game_group_playersValidated
                    ? " opacity-50 cursor-not-allowed hover:"
                    : "hover:text-coolGray-100 hover:bg-emerald-500"
                }`}
                onClick={submitGame}
                disabled={
                  game_group_nameValidated && !game_group_playersValidated
                }
              >
                Create Game
              </button>
            ) : null}
          </div>
        </div>
      </ModalContainer>
      <div className="h-full w-full flex flex-col space-y-3">
        <div className="bg-blueGray-100 w-full h-22 rounded-lg shadow-lg flex justify-between items-center p-5">
          <div className="w-1/2 flex relative">
            <label className="font-semibold mb-1 mr-1 text-coolGray-600 block whitespace-nowrap w-full">
              Search by Tag.
              <input
                className="w-full block border-coolGray-200 rounded-lg shadow-lg mt-2 "
                type="search"
                placeholder="#POLYSCI250, #MYCLASS, ..."
                value={search}
                name="search"
                onChange={(e) => setSearch(e.target.value)}
              />
            </label>
            <svg
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="text-emerald-400 hover:text-coolGray-400 transition absolute right-5 bottom-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <div
            className="py-2 px-5 text-coolGray-600 bg-emerald-400 text-lg font-medium uppercase cursor-pointer transition duration-100 rounded hover:text-coolGray-100 hover:bg-emerald-500"
            onClick={() => toggleGameModal(gameModal)}
          >
            Create a Game
          </div>
        </div>
        <div className="bg-blueGray-100 w-full h-full rounded-lg shadow-lg flex flex-col p-5 overflow-y-auto">
          {game_card_list.map((data) => (
            <ControllerCard
              group_name={data.group_name}
              tags={data.tag_list}
              createdBy={`${user.first_name} ${user.last_name}`}
              OpenGame={false}
              product={data.product}
              user={`${user.first_name} ${user.last_name}`}
              date_created={`${new Date(data.date_created)}`}
            />
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default Games;
